import React from 'react';
import ProductCarouselShell from './ProductCarouselShell';

interface CategoryCarouselProps {
  id: number;
  displayName: string;
  categoryNames: string[];
  load: 'eager' | 'lazy';
  products: any[] | null;
  onAddBag: (product: any, quantity: number) => void;
  onOpenProduct: (product: any) => void;
  onSeeAll: (carouselId: number, categoryNames: string[], displayName: string) => void;
  clientCode?: string;
}

// Lazy loading is driven by the parent list's viewport (onViewableItemsChanged),
// not by this component mounting — so a `lazy` carousel only shows a spinner
// until its data arrives.
const CategoryCarousel: React.FC<CategoryCarouselProps> = ({
  id,
  displayName,
  categoryNames,
  load,
  products,
  onAddBag,
  onOpenProduct,
  onSeeAll,
  clientCode,
}) => {
  const isLoading = load === 'lazy' && products === null;

  return (
    <ProductCarouselShell
      title={displayName}
      products={products}
      loading={isLoading}
      onSeeAll={() => onSeeAll(id, categoryNames, displayName)}
      seeAllLabel="Ver todos"
      onAddBag={onAddBag}
      onOpenProduct={onOpenProduct}
      clientCode={clientCode}
    />
  );
};

export default React.memo(CategoryCarousel);
